import { WrapperWidget } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { T } from '@tolgee/react';

interface Props {
  readonly subscriptions: number;
}

export function EvaluationSubscriptionsWidget(props: Props) {
  if (props.subscriptions === null || props.subscriptions === undefined) {
    return (
      <WrapperWidget>
        <EmptyState
          title={<T>evaluation_subscription_widget_title</T>}
          description={<T>evaluation_subscription_widget_text_1</T>}
        />
      </WrapperWidget>
    );
  }

  return (
    <WrapperWidget>
      <div className="h-full flex flex-col gap-y-6">
        <h2 className="text-lg font-bold">
          <T>evaluation_subscription_widget_title</T>
        </h2>
        <p>
          <T>evaluation_subscription_widget_text_1</T>
        </p>

        <span className="text-3xl">
          {props.subscriptions}{' '}
          <T>evaluation_subscription_widget_interested_parties_text</T>
        </span>
      </div>
    </WrapperWidget>
  );
}
